import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SIDE_NAV_TITLES} from "../../../../common/it-constants";
import {convertToSnakeCase} from "../../../../common/it-utils";
import {fdeNewSecurityDetailObject, fdeNewSecurityObject} from "../../../../common/it-interface";

@Component({
  selector: 'app-new-security-table',
  templateUrl: './new-security-table.component.html',
  styleUrls: ['./new-security-table.component.scss']
})
export class NewSecurityTableComponent implements OnInit {

  @Input() tableDataShow: string;
  @Input() fdeNewSecurities: [];

  @Output() selectRow = new EventEmitter<fdeNewSecurityObject>();

  display = false;
  loading = true;
  newSecurityKey = convertToSnakeCase(SIDE_NAV_TITLES.newSecurity);

  constructor() { }

  ngOnInit() {

  }

  viewDetailData(value) {
    this.selectRow.emit(value)
  }

}
